import React, { memo }  from 'react';
import IconWrapper from './IconWrapper';

const IconLRP = (props) => (
    <IconWrapper fill={props.fill ? props.fill : "#1d3d51"} className={`lrp ${props.className}`} viewBox="0 0 34 28">
        <path d="M31.5,4.5 L4.5,4.5 C2.85,4.5 1.5,5.85 1.5,7.5 L1.5,12 L4.5,12 L4.5,7.5 L31.5,7.5 L31.5,28.5 L21,28.5 L21,31.5 L31.5,31.5 C33.15,31.5 34.5,30.15 34.5,28.5 L34.5,7.5 C34.5,5.85 33.15,4.5 31.5,4.5 Z M1.5,27 L1.5,31.5 L6,31.5 C6,29.01 3.99,27 1.5,27 Z M1.5,21 L1.5,24 C5.64,24 9,27.36 9,31.5 L12,31.5 C12,25.695 7.305,21 1.5,21 Z M1.5,15 L1.5,18 C8.955,18 15,24.045 15,31.5 L18,31.5 C18,22.38 10.605,15 1.5,15 Z M16.5,16.635 L16.5,19.635 L21.75,22.5 L27,19.635 L27,16.635 L21.75,19.5 L16.5,16.635 Z M21.75,9 L13.5,13.5 L21.75,18 L30,13.5 L21.75,9 Z"></path>
    </IconWrapper>
);

export default memo(IconLRP);
